import Vue from 'vue';
import uuidjs from "uuidjs";

export const customIcon = {
    install() {
        const files = require.context('@/components/icons', false, /\.vue$/, 'lazy');
        files.keys().forEach(key => {
            const name = key.slice(key.lastIndexOf('/') + 1).replace('.vue', '');
            Vue.component(name, () => files(key));
        });
    }
};

export function objectToFormData(obj = {}) {
    const formData = new FormData();
    Object.keys(obj).forEach(key => {
        if (obj[key] instanceof Array) {
            obj[key].forEach(item => {
                formData.append(key, item);
            });
            return;
        }
        formData.append(key, obj[key]);
    });
    return formData;
}

export const validateUsername = (rule, value, callback) => {
    const checkUserName = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,10}$/;
    if (value === '') {
        return callback(new Error('请输入用户名'));
    } else if (!checkUserName.test(value)) {
        return callback(new Error('用户名由6~10位数字、字母组成'));
    }
    return callback();
};

export const validatePass = (rule, value, callback) => {
    // 六位数以上，数字符号字母任意两种混合
    // eslint-disable-next-line no-empty-character-class
    const checkPass = /^(?![0-9]+$)(?![a-zA-Z]+$)(?!([^(0-9a-zA-Z)]|[])+$)([^(0-9a-zA-Z)]|[]|[a-zA-Z]|[0-9]){6,}$/;
    if (value === '') {
        return callback(new Error('请输入密码'));
    } else if (!checkPass.test(value)) {
        return callback(new Error('必须六位数以上，数字、符号、字母任意两种混合'));
    }
    return callback();
};

export const checkPhone = (rule, value, callback) => {
    const checkphone = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
    if (!value) {
        return callback(new Error('手机号不能为空!'));
    } else if (!checkphone.test(value)) {
        return callback(new Error('手机号格式错误，请重新输入!'));
    }
    return callback();
};

export const checkEmail = (rule, value, callback) => {
    // eslint-disable-next-line no-useless-escape
    const checkEmail = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
    if (!value) {
        return callback();
    } else if (!checkEmail.test(value)) {
        callback(new Error('邮箱格式错误，请重新输入!'));
    }
    return callback();
};

export const getJsonWrapper = (param, ...args) => {
    const jsonWrapper = {};
    jsonWrapper.p = param;
    args.forEach((item, index) => {
        jsonWrapper[`b${index === 0 ? '' : index}`] = item;
    });
    return jsonWrapper;
};

export const download = url => {
    const downFile = document.createElement('a');
    downFile.href = url;
    downFile.click();
    downFile.remove();
    URL.revokeObjectURL(url);
};

export const uuid = () => {
    return uuidjs.generate().replace(/-/g, '');
};
